function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 168 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "matrix(1,0,0,1,12.9801,-64.9492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-13.0801,65.1492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 180.5,
    width: 49,
    height: 61.5,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 180.5,
    width: 49,
    height: 61.5,
    style: {
      fill: "rgb(247,235,227)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 68.6,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(226,181,165)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.7,108C145.9,105.2 147.9,101.2 147.9,96.7C147.9,92.2 145.9,88.1 142.7,85.3L132.8,96.6L142.7,108Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,68.6L143.8,83.9C147.4,87 149.6,91.6 149.6,96.7C149.6,101.8 147.3,106.4 143.8,109.5L157.1,124.8L157.1,68.6L157.2,68.6Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,96.7C115.8,91.6 118.1,87 121.6,83.9L108.3,68.6L108.3,124.7L121.7,109.4C118,106.3 115.8,101.8 115.8,96.7Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,85.3C119.6,88.1 117.6,92.1 117.6,96.6C117.6,101.1 119.6,105.2 122.8,108L132.7,96.7L122.8,85.3Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7,81.6C136.5,81.6 140,83 142.6,85.3L143.8,83.9C140.8,81.3 136.9,79.7 132.7,79.7C128.4,79.7 124.5,81.3 121.5,83.9L122.7,85.3C125.5,83 128.9,81.6 132.7,81.6Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7,111.8C128.9,111.8 125.5,110.4 122.8,108.1L121.6,109.5C124.6,112.1 128.5,113.7 132.7,113.7C137,113.7 140.9,112.1 143.9,109.5L142.7,108.1C140,110.3 136.5,111.8 132.7,111.8Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 7,
    width: 49,
    height: 61.6,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 39.2,
    r: 16,
    style: {
      fill: "rgb(247,235,227)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 39.2,
    r: 11.7,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 39.2,
    r: 7,
    style: {
      fill: "rgb(247,235,227)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 39.2,
    r: 3.3,
    style: {
      fill: "rgb(186,48,51)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 180.5,
    width: 49,
    height: 61.5,
    style: {
      fill: "rgb(247,235,227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,241.7L83.7,211.2L108.2,180.9L108.2,241.7Z",
    style: {
      fill: "rgb(14,18,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,180.9L83.7,211.3L59.2,241.7L59.2,180.9Z",
    style: {
      fill: "rgb(14,18,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7,
    cy: 210.3,
    r: 16,
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(245,234,226)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,199.6C29.6,198.5 27.8,197.5 26.1,196.4C21.1,199.1 17.8,204.3 17.8,210.3C17.8,216.3 21.2,221.5 26.1,224.2C27.8,223.1 29.6,222 31.5,221C37,217.9 43.7,215.3 49.1,213.5C49.3,212.5 49.4,211.5 49.4,210.4C49.4,209.3 49.3,208.3 49.1,207.3C43.7,205.3 37,202.7 31.5,199.6Z",
    style: {
      fill: "rgb(14,18,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,225.3C19.1,222.2 15.7,216.6 15.7,210.2C15.7,203.8 19.1,198.3 24.2,195.1C18.1,191.1 14.1,187 10.2,180.8L10.2,239.6C14.4,233 18.1,229.3 24.2,225.3Z",
    style: {
      fill: "rgb(14,18,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,210.3C51.4,211.1 51.3,211.9 51.2,212.7C55.9,211.2 59.3,210.3 59.3,210.3C59.3,210.3 56,209.4 51.2,207.9C51.3,208.6 51.4,209.4 51.4,210.3Z",
    style: {
      fill: "rgb(14,18,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6,192.5C30.2,192.5 27,193.5 24.3,195.2C24.9,195.6 25.5,196 26.2,196.4C28.4,195.2 31,194.5 33.7,194.5C41.4,194.5 47.7,199.9 49.2,207.1C49.9,207.3 50.6,207.6 51.3,207.8C50,199.2 42.6,192.5 33.6,192.5Z",
    style: {
      fill: "rgb(186,48,51)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6,226C30.9,226 28.3,225.3 26.1,224.1C25.5,224.5 24.9,224.9 24.2,225.3C26.9,227 30.1,228 33.5,228C42.5,228 49.9,221.3 51.1,212.7C50.4,212.9 49.7,213.2 49,213.4C47.6,220.6 41.2,226 33.6,226Z",
    style: {
      fill: "rgb(186,48,51)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 124.7,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(226,181,165)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,180.9L108.2,124.7L59.2,124.7L108.2,180.9Z",
    style: {
      fill: "rgb(186,48,51)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 124.7,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(14,18,38)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7,
    cy: 152.8,
    r: 16,
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 152.8,
    r: 16,
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.7,
    cy: 152.8,
    r: 11.1,
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,152.8L99.1,152.8",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 68.6,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(226,181,165)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7,128.7L34.7,112.1",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 7,
    width: 49,
    height: 61.6,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,68.6C47.6,69.4 43.5,69.8 34.7,76.1C25.2,69.6 21.5,69.3 10.2,68.6L59.2,68.6Z",
    style: {
      fill: "rgb(186,48,51)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.7,
    cy: 96.7,
    r: 16,
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7,49.7L34.8,39.2L46.8,49.7C49.3,46.9 50.8,43.2 50.8,39.2C50.8,35.2 49.3,31.5 46.8,28.7L34.7,39.2L22.7,28.7C20.2,31.5 18.7,35.2 18.7,39.2C18.7,43.2 20.2,46.9 22.7,49.7Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,28.7C43.9,25.3 39.6,23.2 34.7,23.2C29.9,23.2 25.6,25.3 22.6,28.7L34.6,39.2L46.8,28.7Z",
    style: {
      fill: "rgb(226,181,165)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,49.7L34.8,39.2L22.7,49.7C25.6,53.1 29.9,55.2 34.8,55.2C39.6,55.2 43.9,53.1 46.8,49.7Z",
    style: {
      fill: "rgb(226,181,165)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.6,101.5L34.4,87.1",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1,106.2L26.9,91.8",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "white"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,198.9L132.7,188.5L122.5,197.8C118.9,200.7 116.6,205.2 116.6,210.2C116.6,219.1 123.8,226.2 132.6,226.2C141.5,226.2 148.6,219 148.6,210.2C148.8,205.8 147,201.8 144.1,198.9Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 7,
    width: 49,
    height: 61.6,
    style: {
      fill: "rgb(226,181,165)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 68.6,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(14,18,38)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7,
    cy: 96.7,
    r: 16,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.2C91.4,25.2 97.7,31.5 97.7,39.2C97.7,43.4 95.8,47.4 92.5,50.1C87.2,54.7 84.7,57.1 83.6,58.5C82.4,57.1 79.7,54.4 73.7,49.1C71.1,46.5 69.6,43 69.6,39.2C69.7,31.5 76,25.2 83.7,25.2M83.7,23.2C74.8,23.2 67.7,30.4 67.7,39.2C67.7,43.6 69.5,47.6 72.4,50.5C72.4,50.5 82.6,59.6 82.8,60.6C82.9,61.5 83.7,62.8 83.7,62.8C83.7,62.8 84.6,61.3 84.6,60.6C84.7,59.5 93.8,51.6 93.8,51.6C97.4,48.7 99.7,44.2 99.7,39.2C99.8,30.3 92.6,23.2 83.7,23.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,106.4L83.7,60.1",
    style: {
      fill: "rgb(209,211,212)",
      fillRule: "nonzero",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 124.7,
    width: 49,
    height: 56.1,
    style: {
      fill: "rgb(186,48,51)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.7,152.8C18.7,143.9 25.9,136.8 34.7,136.8C38.7,136.8 42.4,138.3 45.2,140.8L59.2,124.8L10.2,124.8L10.2,180.9L24.2,164.9C20.8,161.9 18.7,157.6 18.7,152.8Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,140.7L24.2,164.8C27,167.3 30.7,168.8 34.7,168.8C43.6,168.8 50.7,161.6 50.7,152.8C50.8,148 48.6,143.7 45.3,140.7Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,89.7L90.7,103.6",
    style: {
      fill: "rgb(209,211,212)",
      fillRule: "nonzero",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,96.7L93.6,96.7",
    style: {
      fill: "rgb(209,211,212)",
      fillRule: "nonzero",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,103.6L90.7,89.7",
    style: {
      fill: "rgb(209,211,212)",
      fillRule: "nonzero",
      strokeWidth: 2,
      stroke: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,9.2L83.7,16.7L59.2,9.2L108.2,9.2Z",
    style: {
      fill: "rgb(247,235,227)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-12.9801,64.8492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.1,1.8L18.1,1.8C12.2,1.8 4.6,9.3 4.6,15.2L4.6,234.4C4.6,240.3 12.2,247.8 18.1,247.8L149.1,247.8C155,247.8 162.6,240.3 162.6,234.4L162.6,15.1C162.6,9.3 155,1.8 149.1,1.8ZM156.6,233.5C156.6,237.9 153,241.5 148.6,241.5L18.6,241.5C14.2,241.5 10.6,237.9 10.6,233.5L10.6,16C10.6,11.6 14.2,8 18.6,8L148.6,8C153,8 156.6,11.6 156.6,16L156.6,233.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-13.1301,64.8992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.5,245L18.9,245C12.7,245 7.6,239.9 7.6,233.7L7.6,15.8C7.6,9.6 12.7,4.5 18.9,4.5L148.6,4.5C154.8,4.5 159.9,9.6 159.9,15.8L159.9,233.7C159.9,239.9 154.8,245 148.5,245Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(186,48,51)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.b5f8f43e5e1b5db02ec2f6b6d6f900e6.svg";
export { ForwardRef as ReactComponent };